import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { useFinancialWarnings } from 'contexts/FinancialWarningsContext';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import {
  calculatePeriodValueBaseOnPreviousPeriodClamped,
  PERIODS_OPERATION_TYPES,
  summarizeSubtractPeriodValues,
} from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetLongTermDebtCalculation = () => {
  const { setValue } = useFormContext();
  const { setExcessiveLoanRepaymentPeriods } = useFinancialWarnings();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [longTermDebtFiled] = observedFields.longTermDebt.setCalculatedValueFieldNames;

  const getLongTermDebtCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const [initialLongTermDebt, proceedsOfDebt, repaymentOfDebt] = content;
        const calculatedDebt = summarizeSubtractPeriodValues(
          [proceedsOfDebt, repaymentOfDebt],
          PERIODS_OPERATION_TYPES.ADD,
        );

        // req 4: clamp long-term debt to non-negative per period; track excessive repayment periods
        const { result: longTermDebt, excessivePeriodKeys } = calculatePeriodValueBaseOnPreviousPeriodClamped(
          calculatedDebt,
          initialLongTermDebt,
        );

        setExcessiveLoanRepaymentPeriods(excessivePeriodKeys);
        setValue(longTermDebtFiled, longTermDebt);
      }, 500),

    [],
  );

  return getLongTermDebtCalculationHandler;
};
